import { apiClient } from '../axios-instance'
import type { AxiosResponse } from 'axios'

export interface PaymentMethodItem {
  id: number
  code: string
  name: string
  description?: string
  icon_name?: string
  bit_value: number
  status: 'active' | 'inactive'
  is_default: boolean
  sort_order: number
  created_at?: string
  updated_at?: string
}

export interface CreatePaymentMethodRequest {
  code: string
  name: string
  description?: string
  icon_name?: string
  status?: 'active' | 'inactive'
  is_default?: boolean
  sort_order?: number
}

export interface UpdatePaymentMethodRequest {
  name?: string
  description?: string
  icon_name?: string
  status?: 'active' | 'inactive'
  is_default?: boolean
  sort_order?: number
}

export const paymentMethodsService = {
  getPaymentMethods: async (): Promise<PaymentMethodItem[]> => {
    const response: AxiosResponse<{ success: boolean; data: PaymentMethodItem[] }> = await apiClient.get(
      '/admin/payment-methods'
    )
    return response.data.data
  },

  createPaymentMethod: async (data: CreatePaymentMethodRequest): Promise<PaymentMethodItem> => {
    const response: AxiosResponse<{ success: boolean; message: string; data: PaymentMethodItem }> = await apiClient.post(
      '/admin/payment-methods',
      data
    )
    return response.data.data
  },

  updatePaymentMethod: async (id: number, data: UpdatePaymentMethodRequest): Promise<PaymentMethodItem> => {
    const response: AxiosResponse<{ success: boolean; message: string; data: PaymentMethodItem }> = await apiClient.put(
      `/admin/payment-methods/${id}`,
      data
    )
    return response.data.data
  },

  updateStatus: async (id: number, status: 'active' | 'inactive'): Promise<PaymentMethodItem> => {
    const response: AxiosResponse<{ success: boolean; message: string; data: PaymentMethodItem }> = await apiClient.patch(
      `/admin/payment-methods/${id}/status`,
      { status }
    )
    return response.data.data
  },
}
